<template>
  <ul
    :class="b()"
    :style="{ height }"
  >
    <li :class="b('action')">
      <c-scroll-top />
    </li>
    <li :class="b('action', { static: true })">
      <c-chat-toggle />
    </li>
    <li
      v-if="$slots.default"
      :class="b('action', { static: true })"
    >
      <!-- @slot allows to add additional content to the sticky toolbar. -->
      <slot></slot>
    </li>
  </ul>
</template>

<script>
  import cChatToggle from '@/components/c-chat-toggle.vue';
  import cScrollTop from '@/components/c-scroll-top.vue';

  /**
   * Renders a list of sticky action buttons.
   */
  export default {
    name: 'c-sticky-toolbar',

    components: {
      cChatToggle,
      cScrollTop,
    },
    // mixins: [],

    // props: {},
    data() {
      return {
        /**
         * Holds the calculated height for the toolbars static content.
         */
        contentHeight: null,
      };
    },

    computed: {
      /**
       * Returns the height the component should take up inside the DOM.
       *
       * @returns {String|null}
       */
      height() {
        return this.contentHeight && !this.$viewport.isMd ? `${this.contentHeight}px` : null;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      this.calculateHeight();

      window.addEventListener('resizeend', this.calculateHeightDebounced);
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    beforeUnmount() {
      window.removeEventListener('resizeend', this.calculateHeightDebounced);
    },
    // unmounted() {},

    methods: {
      /**
       * Debounces the height calculation to make sure childs have been rendered.
       */
      calculateHeightDebounced() {
        setTimeout(this.calculateHeight);
      },

      /**
       * Calculates the height based on the static items.
       */
      calculateHeight() {
        const gap = Number.parseInt(window.getComputedStyle(this.$el).gap || 0, 10);
        let height = 0;

        this.$el.querySelectorAll(`.${this.b('action')}--static`).forEach((element, index) => {
          height += element.offsetHeight + (index ? gap : 0);
        });

        this.contentHeight = height;
      },
    },
    // render() {},
  };
</script>

<style lang="scss">
  // @use 'sass:math';
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  @use '@/setup/scss/extends' as *;

  .c-sticky-toolbar {
    $default-size: variables.$font-size--64;

    @extend %list-reset;
    @include mixins.z-index(front);

    position: sticky;
    bottom: functions.rem(variables.$spacing--40 * 1.5);
    display: flex;
    gap: functions.rem(variables.$spacing--20);
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    margin: functions.rem(variables.$spacing--30 (-1 * variables.$spacing--10) 0 0);

    @media print {
      display: none;
    }

    @include mixins.media(md) {
      height: 0;
      margin: functions.rem(0 (-1 * variables.$spacing--100) 0 0);
    }

    @include mixins.media(xl) {
      bottom: functions.rem(variables.$spacing--100 * 1.5);
      margin-right: -10vw;
    }

    &__action {
      &:empty {
        display: none;
      }

      > * {
        @include mixins.font-size($default-size);

        @include mixins.media(lg) {
          @include mixins.font-size(53px, variables.$font-size--lg-scale-basis); // Align with pagination buttons.
        }
      }
    }
  }
</style>
